import {
  EditButton,
  FunctionField,
  ListButton,
  NumberField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { usePaymentProviderModels } from "@/modules/paymentProviderModel";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <EditButton />
  </TopToolbar>
);

export const TariffShow = () => {
  const { data: { paymentProviderModelsObject } = {} } =
    usePaymentProviderModels();
  return (
    <Show actions={<ShowActions />}>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="createdAt" />
        <TextField source="updatedAt" />
        <TextField source="productId" label="Product Id" />
        <NumberField source="price" />
        <TextField source="publicKey" />
        <TextField source="billingStrategy" />
        <TextField source="clientApp.title" label="Client App" />
        <FunctionField
          source="paymentProviderId"
          render={(record: { paymentProviderId?: string }) => {
            const id = record.paymentProviderId ?? "";
            return paymentProviderModelsObject?.[id] || id;
          }}
        />
        <TextField source="refCommission" />
      </SimpleShowLayout>
    </Show>
  );
};
